import { Button, Modal } from "react-bootstrap";
import React, { useMemo, useState } from "react";

const ModalFeriado = (props) => {
  const { estado, onCloseModal, onReturnValue, rowdata } = props;

  const initialData = {
    CostoHoraProfesional: Number(rowdata?.CostoHoraProfesional ?? 0),
    CostoHoraEmpresa: Number(rowdata?.CostoHoraEmpresa ?? 0),
    horasferiado: Number(rowdata?.horasferiado ?? 0),
    porcentajeferiado: Number(rowdata?.porcentajeferiado ?? 0),
    IdLegajoEnfermeria: rowdata?.IdLegajoEnfermeria,
  };

  const initialEsFeriado =
    rowdata?.esFeriado === "SI"
      ? "SI"
      : "NO";

  const [formData3, setValue] = useState(initialData);
  const [esFeriado, setEsFeriado] = useState(initialEsFeriado);

  const total = useMemo(() => {
    if (esFeriado === "NO") return 0;
    const fer =
      Number(formData3.CostoHoraProfesional || 0) *
      Number(formData3.horasferiado || 0);
    const pct = Number(formData3.porcentajeferiado || 0);
    return Math.round((fer * pct) / 100);
  }, [
    esFeriado,
    formData3.CostoHoraProfesional,
    formData3.horasferiado,
    formData3.porcentajeferiado,
  ]);

  const total2 = useMemo(() => {
    if (esFeriado === "NO") return 0;
    const fer2 =
      Number(formData3.CostoHoraEmpresa || 0) *
      Number(formData3.horasferiado || 0);
    const pct = Number(formData3.porcentajeferiado || 0);
    return Math.round((fer2 * pct) / 100);
  }, [
    esFeriado,
    formData3.CostoHoraEmpresa,
    formData3.horasferiado,
    formData3.porcentajeferiado,
  ]);

  const CalcularHorasTotal = (e) => {
    const { name, value } = e.target;
    setValue((prev) => ({
      ...prev,
      [name]: Number(value),
    }));
  };

  const onChangeEsFeriado = (e) => {
    const v = e.target.value;
    setEsFeriado(v);
    if (v === "NO") {
      // Poner todos los datos editables en 0 e inhabilitar cambios
      setValue((prev) => ({
        ...prev,
        horasferiado: 0,
        porcentajeferiado: 0,
      }));
    }
  };

  const handleSubmit2 = (event) => {
    event.preventDefault();
    const horas = esFeriado === "NO" ? 0 : formData3.horasferiado;
    const porcentaje = esFeriado === "NO" ? 0 : formData3.porcentajeferiado;
    onReturnValue(horas, porcentaje, formData3.IdLegajoEnfermeria, esFeriado);
  };

  const disabledCampos = esFeriado === "NO";

  return (
    <>
      <Modal show={estado} onHide={onCloseModal} size="m">
        <Modal.Header closeButton>
          <Modal.Title>Monto Feriado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="userform">
            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Es Feriado?
                <span className="text-danger">*</span>
              </label>
              <div className="">
                <select
                  className="form-control"
                  name="esFeriado"
                  value={esFeriado}
                  onChange={onChangeEsFeriado}
                >
                  <option value="SI">SI</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>

            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Horas
                <span className="text-danger">*</span>
              </label>
              <div className="">
                <input
                  type="number"
                  className="form-control"
                  name="horasferiado"
                  value={formData3.horasferiado}
                  onChange={CalcularHorasTotal}
                  disabled={disabledCampos}
                  min={0}
                />
              </div>
            </div>

            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Porcentaje
                <span className="text-danger">*</span>
              </label>
              <div className="">
                <input
                  type="number"
                  className="form-control"
                  name="porcentajeferiado"
                  value={formData3.porcentajeferiado}
                  onChange={CalcularHorasTotal}
                  disabled={disabledCampos}
                  min={0}
                />
              </div>
            </div>

            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Total Honorario
                <span className="text-danger">*</span>
              </label>
              <div className="">
                <input
                  type="number"
                  className="form-control"
                  disabled
                  value={total}
                />
              </div>
            </div>

            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Total Tarifa
                <span className="text-danger">*</span>
              </label>
              <div className="">
                <input
                  type="number"
                  className="form-control"
                  disabled
                  value={total2}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onCloseModal}>
            Cerrar
          </Button>
          <Button onClick={handleSubmit2} form="userform">
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalFeriado;